"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSocketNamespace = void 0;
exports.defaultSocketNamespace = '/default';
//# sourceMappingURL=Constants.js.map